import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { forwardRef, useContext, cloneElement, isValidElement, Children } from 'react';
import { VerticalTabsContext } from '../VerticalTabs';
import { StyledTabPanels } from './TabPanels.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var TabPanels = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(VerticalTabsContext),
      selectedIndex = _useContext.index,
      selectedPanelRef = _useContext.selectedPanelRef,
      id = _useContext.id,
      isManual = _useContext.isManual,
      manualIndex = _useContext.manualIndex;

  var clones = Children.map(children, function (child, index) {
    if (!isValidElement(child)) return;
    return cloneElement(child, {
      isSelected: isManual ? index === manualIndex : index === selectedIndex,
      selectedPanelRef: selectedPanelRef,
      id: "".concat(id, "-").concat(index)
    });
  });
  return _jsx(StyledTabPanels, {
    tabIndex: "-1",
    ref: ref,
    children: clones
  });
});
export default TabPanels;